import React from 'react';
import { Download } from 'lucide-react';
import styles from './SaveToCsvButton.scss';

function SaveToCsvButton({ onExport, disabled = false, className = '', isLightMode = false }) {
  const handleClick = (event) => {
    event.stopPropagation();
    if (!disabled && onExport) {
      onExport(event);
    }
  };

  return (
    <button
      type="button"
      className={`${styles.saveToCsvButton} ${isLightMode ? styles.lightMode : ''} ${className}`}
      onClick={handleClick}
      disabled={disabled}
      title="Save to CSV"
    >
      <Download size={14} />
      <span className={styles.label}>Save to CSV</span>
    </button>
  );
}

export default SaveToCsvButton;
